import { render, staticRenderFns } from "./big-loading.vue?vue&type=template&id=4010537f&scoped=true&"
import script from "./big-loading.vue?vue&type=script&lang=ts&"
export * from "./big-loading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010537f",
  null
  
)

export default component.exports